<div class="step-header">
  <div class="title" *ngIf="selectedSiteId === 0">Choose a site to add thresholds</div>
  <div class="title" *ngIf="selectedSiteId > 0">Selected site</div>
</div>
<div class="content" *ngIf="!wizardCtrl.getWizardService().isLoading">
  <div class="site-filter" *ngIf="selectedSiteId === 0">
    <div class="site-filter-wrapper">
      <div class="search-icon"><mat-icon>search</mat-icon></div>
      <input autocomplete="off" class="searchInput" matInput placeholder="Search" [(ngModel)]="searchText" (ngModelChange)="onSearchTextChange($event)">
    </div>
  </div>
  <div class="site-list-container" *ngIf="selectedSiteId === 0">
    <div class="site-list" >
      <div class="site-list-item" *ngFor="let item of dataSource" (click)="chooseSite(item)" >
        <div class="site-name title">{{item.name}}</div>
        <div class="site-location">{{item.location?.city}} , {{item.location?.country}}</div>
      </div>
    </div>
  </div>
  <div class="selected-site-list" *ngIf="selectedSiteId > 0">
    <div class="icon"><img src="{{siteImg}}"></div>
    <div class="site-list-item" >
      <div class="site-name title">{{selectedSiteName}}</div>
      <div class="site-location title"> {{selectedSiteCity}}  {{selectedSiteCountry}}</div>
    </div>
    <div class="action">
      <button mat-raised-button class="btn btn-blue" (click)="resetSelectedSiteInformation()">CHANGE</button>
    </div>
  </div>
</div>
<div *ngIf="wizardCtrl.getWizardService().isLoading" class="loader">
  <div class="loader-msg-header">
    <p>Loading Available Sites...</p>
  </div>
  <mat-spinner></mat-spinner>
  <div class="loader-msg">One moment, please.</div>
</div>
